import React from 'react';
import PropTypes from 'prop-types';

import { OptionalSection, Section } from '@weezevent/nacre';
import Style from './swapDetail.module.css';

import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter } from '../../utils';

function LabelSeating({ seating }) {
    const { t } = useTranslation();

    if (!seating) {
        return null;
    }

    //Check free seating
    if (!seating.seat_uuid && seating.area_zone) {
        return <span>{t('ticket.common.seating.freeSeating')}</span>;
    }

    return (
        <span>
            {`${seating.seat_zone_name}, ${t('ticket.common.seating.labelInfosSeating', {
                seat: seating.seat_seat,
                row: seating.seat_row,
                access: seating.seat_access
            })}`}
        </span>
    );
}

LabelSeating.propTypes = {
    seating: PropTypes.object
};

function LabelUser({ user }) {
    const { t } = useTranslation();

    if (!user.first_name && !user.last_name && !user.email) {
        return null;
    }

    return (
        <div>
            <span className={Style['medium']}>{`${t('ticket.manager.attendees.detail.swapHistory.operator')} `}</span>
            <span>{`${capitalizeFirstLetter(user.first_name)} ${capitalizeFirstLetter(user.last_name)} (${user.email})`}</span>
        </div>
    );
}

LabelUser.propTypes = {
    user: PropTypes.object
};

export default function SwapDetail({ data }) {
    const { t } = useTranslation();

    const [open, setOpen] = React.useState(false);

    if (!data) {
        return null;
    }

    return (
        <>
            <div className={Style['margin-bottom']}>
                <LabelSeating seating={data.new_booking} />
            </div>
            <OptionalSection
                className={open ? Style['optional-section__open'] : ''}
                label={open ? t('ticket.common.seeLessDetails') : t('ticket.common.seeMoreDetails')}
                open={open}
                onToggle={setOpen}
            >
                <Section className={Style['section']}>
                    <div className={Style['margin-bottom']}>
                        <span className={Style['medium']}>{`${t('ticket.manager.attendees.detail.swapHistory.oldSeating')} `}</span>
                        <LabelSeating seating={data.old_booking} />
                    </div>
                    <LabelUser user={data.request_user} />
                </Section>
            </OptionalSection>
        </>
    );
}

SwapDetail.propTypes = {
    data: PropTypes.object
};
